import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

/* eslint-disable complexity */
const useBRRedesignOpacity = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const brRedesignOpacityFeatureEnabled = useEnabledFeature(
    'cat-br-redesign-opacity'
  );

  const brRedesignOpacityExperimentEnabled = useEnabledSegment(
    `${abbrBrand}142`
  );

  return (
    brRedesignOpacityFeatureEnabled &&
    brRedesignOpacityExperimentEnabled &&
    (abbrBrand === 'br' || abbrBrand === 'brfs')
  );
};

export default useBRRedesignOpacity;
